import HeaderExpansibleBase from 'components/landing/tables/components/expandible-table-items-base/header-expansible-base';
import Image from 'core/image';
import insuranceLogoMapper from 'utils/insurance-logo-mapper/insurance-logo-mapper';
import PropTypes from 'prop-types';
import styles from 'styles/LandingExpansibleTable.module.scss';
import useRichTranslation from 'hooks/useRichTranslation';

/**
 * # QuotationByCarCategoryHeader
 * @description Component that return the header of the
 * QuotationByCarCategory table.
 * @component
 * @example
 * const companyCode = 'allianz'
 * const culture = 'es-ar'
 * const colorSchema= '#00F';
 *
 * return (
 *   <QuotationByCarCategoryHeader
 *     companyCode={companyCode}
 *     culture={culture}
 *     colorSchema={colorSchema}
 *   />
 * )
 */
const QuotationByCarCategoryHeader = ({
    companyCode,
    culture,
    colorSchema
}) => {
    const t = useRichTranslation('table.quotation-by-car-category');
    return (
        <HeaderExpansibleBase
            colorSchema={colorSchema}
            isOpen={false}
            topNode={
                <Image
                    src={insuranceLogoMapper(companyCode, culture, 'white')}
                    alt={`${companyCode} Logo`}
                    width={170.21}
                    height={60}
                />
            }
            midNode={
                <div className={styles.header__mid_label}>
                    <p>{t('header-label')}</p>
                </div>
            }
        />
    );
};

QuotationByCarCategoryHeader.propTypes = {
    /** Code of the company, to map trough the company logo mapper */
    companyCode: PropTypes.string,
    /** Indicates the culture of the company Logo */
    culture: PropTypes.string,
    /** Indicate the color background of the header item */
    colorSchema: PropTypes.string
};

export default QuotationByCarCategoryHeader;
